/**
 * App stacking scale. Use the token that matches the layer's role.
 * Do not reuse loginModal / loadingOverlay / toast for nested dialogs or pickers.
 *
 * Toast and loading are never covered by app UI. Re-auth sits below both;
 * opening login dismisses loading so the two never compete.
 */
export const Z_INDEX = {
  /** In-page FABs / speed dials — below app bar and overlays */
  fab: 1050,
  appBar: 1100,
  drawer: 1200,
  menu: 1300,
  dialog: 1350,
  /** Pickers, autocomplete, pack helper, export menus on a dialog */
  dialogPopover: 1360,
  /** Pending-task drawer — above dialogs, below nested dialogs */
  taskPane: 1370,
  /** Second dialog opened from another (reports, tender, wallet post) */
  nestedDialog: 1380,
  /** Dialog opened from a nested one (line image picker and its editor) */
  deepDialog: 1385,
  /** Pickers / menus inside a nested dialog */
  nestedPopover: 1390,
  /** Confirmations sit above the dialog they confirm, including nested ones */
  confirm: 1400,
  snackbar: 1500,
  tooltip: 1510,
  /** Socket-offline backdrop */
  offline: 1600,
  /** POS disconnect animation */
  shutdown: 1700,
  /** Re-auth modal. Below loading and toasts. */
  loginModal: 1800,
  /** Full-app spinner — never covered by app UI */
  loadingOverlay: 2000,
  /** Toasts — never covered */
  toast: 2100,
} as const;
